import React, { FC, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // Importation de useNavigate
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO_2 } from "data/navigation";
import "../../styles/styles.css";
import loupe from "../../images/loupe.png";

interface Props {
  className?: string;
}

const Navigation: FC<Props> = ({ className = "flex" }) => {
  const [isRecherche, setIsRecherche] = useState(false);
  const [recherche, setRecherche] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null); // Référence à l'input de recherche
  const navigate = useNavigate(); // Hook pour naviguer

  // Fonction pour activer/désactiver la recherche
  const rechercher = () => {
    setIsRecherche((prev) => !prev); // Inverse la visibilité de l'input recherche
  };

  // Fonction pour gérer la recherche lorsqu'on appuie sur "Rechercher" ou "Enter"
  const chercher = (e: React.FormEvent) => {
    e.preventDefault();
    if (recherche.trim()) {
      // Utiliser `navigate` pour changer dynamiquement l'URL
      navigate(`/recherche?q=${encodeURIComponent(recherche)}`);
    }
  };

  // Fonction pour mettre à jour la recherche
  const rechercheChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRecherche(e.target.value);
  };

  // Focus automatiquement sur l'input de recherche lorsqu'il devient visible
  useEffect(() => {
    if (isRecherche && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isRecherche]); // Se déclenche lorsque isRecherche devient true

  return (
    <div style={{ marginLeft: "-100px" }}>
      <ul className={`nc-Navigation items-center ${className}`}>
        {NAVIGATION_DEMO_2.map((item) => (
          <NavigationItem key={item.id} menuItem={item} />
        ))}
        <img src={loupe} width="20" onClick={rechercher} />

        {/* Affichage de l'input de recherche si isRecherche est true */}
        {isRecherche && (
          <div>
            <input
              ref={inputRef} // Associe la référence à l'input
              value={recherche}
              onChange={rechercheChange}
              style={{ width: "100px", height: "30px" }}
              type="text"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  chercher(e);
                }
              }}
            />
            <button onClick={chercher} className="boutonRecherche">
              Rechercher
            </button>
          </div>
        )}
      </ul>
    </div>
  );
};

export default Navigation;
